const Modules = [
  {
    id: 1,
    module: "Inventory",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 2,
    module: "Product",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 3,
    module: "Vendor",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 4,
    module: "Staff",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 5,
    module: "Roles & Permissions",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 6,
    module: "Audit Logs",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: false,
    isEdit: false,
    isDelete: false,
  },
  {
    id: 7,
    module: "Department",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 8,
    module: "Category",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 9,
    module: "Class",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 10,
    module: "Program Build",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 11,
    module: "Stone",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
  {
    id: 12,
    module: "Brand",
    viewGlobal: 0,
    view: 0,
    add: 0,
    edit: 0,
    delete: 0,
    isAdd: true,
    isEdit: true,
    isDelete: true,
  },
]

export default Modules
